import React, { JSX } from "react";
import { TEmblaSliderElement } from "./types";

export type TSlideWidith = "auto" | `${number}%`;

type TPropsEmblaSliderContainer = {
  gap: number;
  slides: {
    width: TSlideWidith;
    component: React.ReactElement | JSX.Element;
  }[];
  direction?: "vertical" | "horizantal";
  height?: number;
  id?: string | number;
  extraClassName?: string;
};

const EmblaSliderContainer: React.FC<
  TEmblaSliderElement & TPropsEmblaSliderContainer
> = ({
  children,
  className = "Embla-Slider-container",
  gap,
  slides,
  direction,
  height,
  id,
  extraClassName,
}) => {
  const buildWidth = (width: TSlideWidith) => {
    if (width === "auto") {
      return {
        flex: "0 0 auto",
        maxWidth: "100%",
      };
    }
    return { flex: `0 0 ${width}` };
  };

  return (
    <ul
      id={id ? `${id}_embla_slider_container` : undefined}
      className={extraClassName ? `${className} ${extraClassName}` : className}
      style={{
        gap,
        width: "100%",
        flexDirection: direction === "vertical" ? "column" : "row",
        height,
        listStyleType: "none",
        margin: 0,
        padding: 0,
      }}
    >
      {slides.map(({ component, width }, i) => {
        return (
          <li
            className={`li-${extraClassName ?? ""}`}
            id={id ? `${id}_slider_item_${i}` : undefined}
            key={i}
            style={{ ...buildWidth(width) }}
          >
            {component}
          </li>
        );
      })}
      {children}
    </ul>
  );
};

export default EmblaSliderContainer;
